export default __webpack_public_path__ + "static/media/couple-looking-house.952363e6.webp";